{
  "steel": {
    "color": 13488598,
    "roughness": 0.58,
    "metalness": 1,
    "envMapIntensity": 0.7
  },
  "ring": {
    "color": 2441027,
    "roughness": 0.52,
    "metalness": 0,
    "emissive": 4955563,
    "emissiveIntensity": 0.18,
    "boardIntensity": 0
  },
  "skirt": {
    "color": 3751233,
    "roughness": 0.65,
    "metalness": 0,
    "edgeColor": 4955563,
    "edgeIntensity": 0.045,
    "edgeHeight": 0.008
  }
}
